import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl as withIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';

import getDeliveryInfo from '@core/reducers/shop/selectors/getDeliveryInfo';
import getUseLiveOrderTracking from '@core/reducers/shop/selectors/getUseLiveOrderTracking';
import getCartIsPickUp from '@core/reducers/cart/selectors/getCartIsPickUp';
import trackModalOpened from '@tracking/actions/trackModalOpened';
import trackModalClosed from '@tracking/actions/trackModalClosed';

const mapStateToProps = createStructuredSelector({
  deliveryMessage: getDeliveryInfo,
  isLogisticsDelivery: getUseLiveOrderTracking,
  isPickup: getCartIsPickUp,
});

const mapDispatchToProps = {
  trackModalOpened,
  trackModalClosed,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter, withIntl);
